import { Card, Button, SkeletonBodyText } from "@shopify/polaris";
import { useSelector } from "react-redux";
import downloadFile from "../../services/DownloadFile";
import styles from "./GuidenceList.module.css";

export default function GuidenceList() {
    const activeInspection = useSelector(
        (state: any) => state.portal.activeInspection
    );
    let guidenceElements: any[] = [];
    if (activeInspection) {
        guidenceElements = activeInspection.sections.filter(
            (section: any) => section.Guideline === true
        );
    }

    function onDownload(asset: any) {
        downloadFile(
            asset.checkList.template.url,
            asset.checkList.template.name
        );
    }

    const downloadIcon = () => {
        return (
            <img
                className={styles.icon}
                alt={"download asset"}
                width="20"
                height="20"
                src="/images/Download-Icon.svg"
            />
        );
    };

    return (
        <Card>
            {activeInspection ? (
                <ul className={styles.guidenceList}>
                    {guidenceElements.map((data, i) => {
                        // eslint-disable-next-line no-prototype-builtins
                        if (data.checkList.hasOwnProperty("template")) {
                            return (
                                <li key={data.Id}>
                                    <div className={styles.guidenceName}>
                                        {data.Name}
                                    </div>
                                    <div className={styles.guidenceFileName}>
                                        {data.checkList.template.name}
                                    </div>
                                    <div className={styles.guidenceDownload}>
                                        <span
                                            className={
                                                styles.template_download_button
                                            }
                                        >
                                            <Button
                                                onClick={() => onDownload(data)}
                                                icon={downloadIcon()}
                                                size="large"
                                            >
                                                Download
                                            </Button>
                                        </span>
                                    </div>
                                </li>
                            );
                        } else {
                            return <div />;
                        }
                    })}
                </ul>
            ) : (
                <div>
                    <Card sectioned>
                        <SkeletonBodyText />
                    </Card>
                </div>
            )}
        </Card>
    );
}
